import { render, staticRenderFns } from "./ComplementaryTherapiesSection.vue?vue&type=template&id=00647d0b&scoped=true&"
import script from "./ComplementaryTherapiesSection.vue?vue&type=script&lang=js&"
export * from "./ComplementaryTherapiesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00647d0b",
  null
  
)

export default component.exports